// Held keys / buttons as the input sampler sees them. A press shorter than one tick (a quick
// mouse click, a key tap between two sampled ticks) is latched so the next sample still sees it
// exactly once; wheel notches are latched presses without a physical key.

export class HeldBindings {
  /** Physically down (key or mouse button). */
  readonly down = new Set<string>();
  /** What the next sample sees: `down` plus latched taps. */
  readonly held = new Set<string>();
  private readonly latched = new Set<string>();

  /** `physical` false for wheel notches (no release event follows). */
  press(binding: string, physical: boolean): void {
    if (physical) this.down.add(binding);
    this.held.add(binding);
    this.latched.add(binding);
  }

  release(binding: string): void {
    this.down.delete(binding);
    if (!this.latched.has(binding)) this.held.delete(binding);
  }

  /** After a sample: taps have been delivered once; keep only what is still physically down. */
  endSample(): void {
    if (this.latched.size === 0) return;
    for (const b of this.latched) if (!this.down.has(b)) this.held.delete(b);
    this.latched.clear();
  }

  clear(): void {
    this.down.clear();
    this.held.clear();
    this.latched.clear();
  }
}
